import { Alert, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";

import type { ClientCdpB2bChannel, ClientCdpB2bDeliverySite } from "../../../../lib/api/types";
import Client360ChannelFieldGrid from "./Client360ChannelFieldGrid";

function display(value: string | number | null | undefined) {
    if (value === null || value === undefined || value === "") {
        return "—";
    }

    return String(value);
}

export default function Client360B2bChannelTab({ channel }: { channel: ClientCdpB2bChannel }) {
    if (!channel.hasData) {
        return <Alert severity="info">Няма B2B данни (ЕИК, Expo обекти или търговски условия) за този клиент.</Alert>;
    }

    return (
        <Stack spacing={2}>
            <Client360ChannelFieldGrid
                title="B2B — фирма"
                subtitle=""
                rows={[
                    { label: "Фирма", value: display(channel.companyName) },
                    { label: "ЕИК", value: display(channel.eik) },
                    { label: "ДДС номер", value: display(channel.vatNumber) },
                    { label: "Регистриран адрес", value: display(channel.registeredAddress) },
                    { label: "Регион", value: display(channel.region) },
                    { label: "МОЛ", value: display(channel.mol) },
                    { label: "Отстъпка", value: display(channel.discount) },
                    { label: "Плащане", value: display(channel.paymentTerms) },
                    { label: "Кредитен лимит", value: display(channel.creditLimit) },
                    { label: "Последна поръчка", value: display(channel.lastOrderAt) },
                    { label: "Търговец (Expo)", value: display(channel.primaryTraderName) },
                    { label: "Маршрут (Expo)", value: display(channel.primaryRouteName) },
                    { label: "Expo поръчки", value: display(channel.expoOrderCount) },
                    { label: "Expo обекти", value: display(channel.expoSiteCount) },
                    {
                        label: "Expo оборот",
                        value:
                            channel.expoTurnover !== undefined && channel.expoTurnover > 0
                                ? `${channel.expoTurnover.toLocaleString("bg-BG")} лв.`
                                : "—",
                    },
                ]}
            />

            <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                    Обекти (Expo)
                </Typography>
                {channel.deliverySites.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        Няма открити поръчки за този клиент
                    </Typography>
                ) : (
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Обект</TableCell>
                                <TableCell>Клиентско име</TableCell>
                                <TableCell>Маршрут</TableCell>
                                <TableCell>Търговец</TableCell>
                                <TableCell>Последна поръчка</TableCell>
                                <TableCell align="right">Поръчки</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {channel.deliverySites.map((site: ClientCdpB2bDeliverySite) => (
                                <TableRow key={`${site.objectName}-${site.clientName}`}>
                                    <TableCell>{site.objectName}</TableCell>
                                    <TableCell>{site.clientName}</TableCell>
                                    <TableCell>{display(site.routeName)}</TableCell>
                                    <TableCell>{display(site.traderName)}</TableCell>
                                    <TableCell>
                                        {site.lastOrderAt
                                            ? new Date(site.lastOrderAt).toLocaleDateString("bg-BG")
                                            : "—"}
                                    </TableCell>
                                    <TableCell align="right">{site.orderCount}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </Paper>
        </Stack>
    );
}
